import React, { Component } from "react";
import queryString from "query-string";

import * as Constant from "@app/Constant.js";
import axios from "@app/lib/axios";
import { toast, ToastContainer, Slide } from "react-toastify";

import * as date_util from "@app/lib/date_util";
import * as util from "@app/lib/utility";

import SelectBizYear from "./components/SelectBizYear";
import CardStatContract from "./components/CardStatContract";
import CardStatContractApp from "./components/CardStatContractApp";
import ContractChart from "./components/ContractChart";
import TerminateChart from "./components/TerminateChart";
import MonthlyChart from "./components/MonthlyChart";
import ContractClassify from "./components/ContractClassify";
import StatList from "./components/StatList";
import BCGScatter from "./components/BCGScatter";

import "./components/style.css";
import { isRoleBranch } from "@app/lib/utility";

const calculateData = (_new, _renew, _terminate, last_new, last_renew, last_terminate) => {
    return {
        total: _new + _renew,
        total_growth:
            last_new + last_renew == 0 && last_new + last_renew > 0 ? 100 : last_new + last_renew <= 0 ? 0 : Math.ceil(((_new + _renew - (last_new + last_renew)) / (last_new + last_renew)) * 100),

        new_growth: last_new == 0 && _new > 0 ? 100 : last_new == 0 && _new <= 0 ? 0 : Math.ceil(((_new - last_new) / last_new) * 100),

        renew_growth: last_renew == 0 ? 0 : Math.ceil(((_renew - last_renew) / last_renew) * 100),

        last_total: last_new + last_renew,

        renew_rate: last_new + last_renew == 0 ? 0 : Math.ceil((_renew / (last_new + last_renew)) * 100),
        terminate_rate: _new == 0 ? 0 : Math.ceil((_terminate / _new) * 100),

        new: _new,
        renew: _renew,
        terminate: _terminate,
        last_new: last_new,
        last_renew: last_renew,
        last_terminate: last_terminate,
    };
};
const calculateDataKeezle = (_new, _old, _re_target, _renew, _terminate, last_new, last_old, last_renew, last_terminate) => {
    return {
        total: _new + _renew + _old,
        total_growth: last_new + last_old + last_renew == 0 ? 100 : Math.ceil(((_new + _renew + _old - (last_new + last_renew + last_old)) / (last_new + last_renew + last_old)) * 100),

        new_growth: last_new == 0 && _new > 0 ? 100 : last_new == 0 && _new <= 0 ? 0 : Math.ceil(((_new - last_new) / last_new) * 100),

        renew_growth: last_renew == 0 ? (_renew > 0 ? 100 : 0) : Math.ceil(((_renew - last_renew) / last_renew) * 100),

        last_total: _re_target,

        renew_rate: _re_target == 0 ? 0 : Math.ceil((_renew / _re_target) * 100),
        terminate_rate: _new == 0 ? 0 : Math.ceil((_terminate / (last_new + last_old + last_renew)) * 100),

        new: _new,
        renew: _renew,
        terminate: _terminate,
        last_new: last_new,
        last_renew: last_renew,
        last_terminate: last_terminate,
    };
};

class TasBranch extends Component {
    constructor(props) {
        super(props);
        const query = queryString.parse(this.props.location.search);

        const isRoleBranch = util.isRoleBranch();
        const branchId = isRoleBranch ? localStorage.getItem("login_branch_id") : query.id;
        const branchName = isRoleBranch ? localStorage.getItem("login_branch_name") : decodeURIComponent(query.name);

        var year = query && query.year ? query.year : new Date().getFullYear();
        var app = query && query.app ? query.app : "tomonote";

        this.state = {
            isRoleBranch,
            branchId,
            branchName,
            isBaseDataLoaded: false,
            isDataLoading: false,
            defaultSelectedYear: year,
            selectedBizYear: null,
            bizYearList: null,
            nurseries: null,
            selectedApp: null,
            statMonthly: null,
            statNurseries: null,
            appInfo: null,
            unionInfo: null,
            statAppAll: null,
            statAppUnionAll: null,
            timestatAppAll: false,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const { branchId } = this.state;
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/tas_stat_v4/app/all`,
        })
            .then((resultApp) => {
                if (resultApp.data.code === 200) {
                    const appInfo = [];
                    const unionInfo = [];
                    for (let i = 0; i < resultApp.data.data.length; i++) {
                        if(appInfo.findIndex((a) => a.id == resultApp.data.data[i].id)) {
                            appInfo.push({
                                id: resultApp.data.data[i].id,
                                name: resultApp.data.data[i].name,
                                typeName: null,
                                typeId: null,
                                selected: i === 0 ? true : false,
                                stat: {},
                                statClassify: { age: [], years: [], nurseryType: [] },
                            });
                        }
                        if(resultApp.data.data[i].type) {
                            unionInfo.push({
                                id: resultApp.data.data[i].id,
                                name: resultApp.data.data[i].name,
                                typeName: resultApp.data.data[i].typeName,
                                typeId: resultApp.data.data[i].type,
                                typeUse: resultApp.data.data[i].use,
                                selected: false,
                                stat: {},
                                statClassify: { age: [], years: [], nurseryType: [] },
                            });
                        }
                    }
                    axios({
                        method: "get",
                        url: `${Constant.API_DOMAIN}/api/tas_stat_v4/biz_year/all`,
                    })
                        .then((result) => {
                            if (result.data.code === 200) {
                                const { defaultSelectedYear } = this.state;
                                let selectedBizYear = null;
                                const currentYearMonth = date_util.getFormatDateyyyyMM(new Date());
                                for (let i = 0; i < result.data.data.length; i++) {
                                    if (currentYearMonth >= result.data.data[i].start && currentYearMonth <= result.data.data[i].end) {
                                        result.data.data[i].yearStatMonth = currentYearMonth;
                                    } else {
                                        result.data.data[i].yearStatMonth = result.data.data[i].end;
                                    }
                                    if (defaultSelectedYear == result.data.data[i].year) {
                                        selectedBizYear = result.data.data[i];
                                    }
                                }
                                this.setState(
                                    {
                                        appInfo: appInfo,
                                        unionInfo: unionInfo,
                                        selectedBizYear: selectedBizYear,
                                        bizYearList: result.data.data,
                                    },
                                    () => {
                                        axios({
                                            method: "get",
                                            url: `${Constant.API_DOMAIN}/api/tas_stat_v4/branch/${branchId}/nurseries`,
                                        })
                                            .then((result) => {
                                                if (result.data.code === 200) {
                                                    this.setState(
                                                        {
                                                            nurseries: result.data.data,
                                                            isBaseDataLoaded: true,
                                                        },
                                                        () => {
                                                            this.getYearStatAll()
                                                                .then(() => {
                                                                    this.getYearStatData()
                                                                        .then(() => {})
                                                                        .catch((err) => {
                                                                            toast.error(err.msg);
                                                                        });
                                                                })
                                                                .catch((err) => {
                                                                    toast.error(err.msg);
                                                                });
                                                        }
                                                    );
                                                } else {
                                                    toast.error(result.data.msg);
                                                }
                                            })
                                            .catch((error) => {
                                                console.log(error);
                                                toast.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                                            });
                                    }
                                );
                            } else {
                                toast.error(result.data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            toast.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                        });
                } else {
                    toast.error(resultApp.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }

    getYearStatAll() {
        return new Promise((resolve, reject) => {
            const { branchId } = this.state;
            this.setState({ isDataLoading: true }, () => {
                axios({
                    method: "post",
                    url: `${Constant.API_DOMAIN}/api/tas_stat_v4/branch/${branchId}/app/all/stat`,
                    data: {
                        yearStatMonth: this.state.bizYearList.map((y) => y.yearStatMonth),
                    },
                })
                    .then((result) => {
                        if (result.data.code === 200) {
                            if (result.data.data) {
                                result.data.dataUnion.forEach((stat) => {
                                    const app = this.state.unionInfo.find((a) => a.id === stat.appId && a.typeId === stat.appAuthType);
                                    if (app) {
                                        app.stat[stat.year] = { ...stat };
                                    }
                                });
                                result.data.data.forEach((stat) => {
                                    const app = this.state.appInfo.find((a) => a.id === stat.appId);
                                    if (app) {
                                        app.stat[stat.year] = { ...stat };
                                    }
                                });
                                this.state.appInfo.forEach((a) => {
                                    a.statClassify = { age: [], years: [], nurseryType: [] };
                                    a.statClassify.age = result.data.statAge.filter((s) => (s.appAuthType ? s.appId === a.id && s.appAuthType === a.typeId : s.appId === a.id));
                                    a.statClassify.years = result.data.statYears.filter((s) => (s.appAuthType ? s.appId === a.id && s.appAuthType === a.typeId : s.appId === a.id));
                                    a.statClassify.nurseryType = result.data.statNurseryType.filter((s) => (s.appAuthType ? s.appId === a.id && s.appAuthType === a.typeId : s.appId === a.id));
                                });
                                // 재계약률/해지율 계산
                                this.state.appInfo.forEach((app) => {
                                    for (const year in app.stat) {
                                        var current = app.stat[year];
                                        const last = app.stat[year - 1];
                                        if (app && app.id == "keezle") {
                                            current.countApOld = current.countApOld - current.countApRe;
                                            current.total = current.countApNew + current.countApRe + current.countApOld + current.countNaNew + current.countNaRe;
                                            current.rateRe = current.countReTarget > 0 ? Math.ceil((current.countApRe / current.countReTarget) * 100) : 0;
                                            current.rateTerminate = current.total ? Math.ceil(((current.countNaNew + current.countNaRe) / current.total) * 100) : 0;
                                        } else {
                                            current.total = current.countApNew + current.countApRe + current.countNaNew + current.countNaRe;
                                            current.rateRe = last ? Math.ceil((current.countApRe / (last.countApNew + last.countApRe)) * 100) : 0;
                                            current.rateTerminate = current.total ? Math.ceil(((current.countNaNew + current.countNaRe) / current.total) * 100) : 0;
                                        }
                                    }
                                });
                                // 결합상품 - 재계약률/해지율 계산
                                this.state.unionInfo.forEach((app) => {
                                    for (const year in app.stat) {
                                        var current = app.stat[year];
                                        const last = app.stat[year - 1];
                                        if (app && app.id == "keezle") {
                                            current.countApOld = current.countApOld - current.countApRe;
                                            current.total = current.countApNew + current.countApRe + current.countApOld + current.countNaNew + current.countNaRe;
                                            current.rateRe = current.countReTarget > 0 ? Math.ceil((current.countApRe / current.countReTarget) * 100) : 0;
                                            current.rateTerminate = current.total ? Math.ceil(((current.countNaNew + current.countNaRe) / current.total) * 100) : 0;
                                        } else {
                                            current.total = current.countApNew + current.countApRe + current.countNaNew + current.countNaRe;
                                            current.rateRe = last ? Math.ceil((current.countApRe / (last.countApNew + last.countApRe)) * 100) : 0;
                                            current.rateTerminate = current.total ? Math.ceil(((current.countNaNew + current.countNaRe) / current.total) * 100) : 0;
                                        }
                                    }
                                });
                            }
                            if (this.state.selectedApp === null) {
                                const query = queryString.parse(this.props.location.search);
                                this.setState(
                                    {
                                        selectedApp: this.state.appInfo.find((a) => a.id === "tomonote"),
                                        statAppAll: this.state.appInfo,
                                        statAppUnionAll: this.state.unionInfo,
                                        timestatAppAll: new Date().getTime(),
                                        isDataLoading: false,
                                    },
                                    () => {
                                        resolve();
                                    }
                                );
                            } else {
                                this.setState(
                                    {
                                        statAppAll: this.state.appInfo,
                                        timestatAppAll: new Date().getTime(),
                                        isDataLoading: false,
                                    },
                                    () => {
                                        resolve();
                                    }
                                );
                            }
                        } else {
                            this.setState({ isDataLoading: false }, () => {
                                reject(result.data);
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        reject({
                            code: 999,
                            msg: "알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.",
                        });
                    });
            });
        });
    }

    getYearStatData() {
        return new Promise((resolve, reject) => {
            const { branchId } = this.state;
            const { selectedApp, selectedBizYear } = this.state;
            this.setState({ isDataLoading: true }, () => {
                axios({
                    method: "get",
                    url: `${Constant.API_DOMAIN}/api/tas_stat_v4/branch/${branchId}/app/${selectedApp.id}/appType/${selectedApp.typeId}/stat/${selectedBizYear.year}`,
                })
                    .then((result) => {
                        if (result.data.code === 200) {
                            var statMonthly = [];
                            var statNurseries = [];
                            if (result.data) {
                                statMonthly = result.data.month;
                                result.data.nurseries.forEach((stat) => {
                                    var nursery =
                                        selectedApp.id == "keezle" ? result.data.contractNurseries.find((n) => n.id == stat.nurseryId) : this.state.nurseries.find((n) => n.id == stat.nurseryId);
                                    var statNursery = nursery ? statNurseries.find((n) => n.id == nursery.uniqId) : null;
                                    if (statNursery) {
                                        if (!statNursery.stat) {
                                            statNursery.stat = {};
                                        }
                                        if(statNursery.stat[stat.year]) {
                                            Object.keys(stat).forEach((k) => statNursery.stat[stat.year][k] += stat[k]);
                                        } else {
                                            statNursery.stat[stat.year] = stat;
                                        }
                                    } else {
                                        if (nursery) {
                                            var clone = { id: nursery.uniqId, name: nursery.name, stat: {} };
                                            clone.stat[stat.year] = stat;
                                            statNurseries.push(clone);
                                        }
                                    }
                                });
                                if (statNurseries) {
                                    const yearCurrent = selectedBizYear.year;
                                    const yearLast = yearCurrent - 1;
                                    const yearTotal = selectedApp.stat[yearCurrent]
                                        ? selectedApp.stat[yearCurrent].countApNew + (selectedApp.stat[yearCurrent].countApRe || 0) + (selectedApp.stat[yearCurrent].countApOld || 0)
                                        : 0;
                                    statNurseries.forEach((n) => {
                                        const statYear = n.stat[yearCurrent];
                                        const statLast = n.stat[yearLast];
                                        if (selectedApp.id == "keezle") {
                                            n.statYear = calculateDataKeezle(
                                                statYear ? statYear.countApNew || 0 : 0,
                                                statYear ? statYear.countApOld || 0 : 0,
                                                statYear ? statYear.countReTarget || 0 : 0,
                                                statYear ? statYear.countApRe || 0 : 0,
                                                statYear ? statYear.countNaRe || 0 : 0,
                                                statLast ? statLast.countApNew || 0 : 0,
                                                statLast ? statLast.countApOld || 0 : 0,
                                                statLast ? statLast.countApRe || 0 : 0,
                                                statLast ? statLast.countNaRe || 0 : 0
                                            );
                                        } else {
                                            n.statYear = calculateData(
                                                statYear ? statYear.countApNew || 0 : 0,
                                                statYear ? statYear.countApRe || 0 : 0,
                                                statYear ? statYear.countNaRe || 0 : 0,
                                                statLast ? statLast.countApNew || 0 : 0,
                                                statLast ? statLast.countApRe || 0 : 0,
                                                statLast ? statLast.countNaRe || 0 : 0
                                            );
                                        }
                                        n.statYear.rate = yearTotal == 0 ? 0 : (n.statYear.total / yearTotal) * 100;
                                        // 파생상품 랜덤
                                        n.statYear.derivative = Math.ceil(Math.random() * (4000 - 300) + 300);
                                    });
                                }
                            }
                            this.setState(
                                {
                                    statMonthly,
                                    statNurseries,
                                    timeCurrent: new Date().getTime(),
                                    isDataLoading: false,
                                },
                                () => {
                                    // (this.state);
                                    resolve();
                                }
                            );
                        } else {
                            this.setState({ isDataLoading: false });
                            reject(result.data);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        reject({
                            code: 999,
                            msg: "알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.",
                        });
                    });
            });
        });
    }

    onYearSearchHandler(year) {
        if (this.state.selectedBizYear && this.state.selectedBizYear.year !== year) {
            const selected = this.state.bizYearList.find((y) => y.year == year);
            if (selected) {
                this.setState({ selectedBizYear: selected }, () => {
                    this.getYearStatData();
                });
            }
        }
    }

    onAppSelect(appId, appType) {
        if (this.state.selectedApp.id !== appId || this.state.selectedApp.type !== appType) {
            let selected = null;
            if(appType) {
                selected = this.state.statAppUnionAll.find((a) => (appType ? a.id === appId && a.typeId == appType : a.id === appId));
            } else {
                selected = this.state.statAppAll.find((a) => (appType ? a.id === appId && a.typeId == appType : a.id === appId));
            }
            this.setState(
                {
                    selectedApp: selected,
                },
                () => {
                    this.getYearStatData();
                }
            );
        }
    }

    render() {
        const { isRoleBranch, branchName, isBaseDataLoaded, selectedBizYear, bizYearList, selectedApp, statAppAll, statAppUnionAll, statMonthly, statNurseries } = this.state;

        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <div className="col">
                                <div className="page-header">
                                    <h2 className="pageheader-title">계약 지표</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid dashboard-content ">
                        <div className="row align-items-center mb-3">
                            {!isRoleBranch && (
                                <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4" style={{ minWidth: "59px", maxWidth: "59px", marginTop: "-5px" }}>
                                    <button
                                        className="btn btn-default"
                                        style={{
                                            border: "0px",
                                            width: "44px",
                                        }}
                                        type="button"
                                        onClick={() => {
                                            const { history } = this.props;
                                            history.goBack();
                                        }}
                                    >
                                        <span className="fa fa-lg fa-chevron-left" aria-hidden="true" />
                                    </button>
                                </div>
                            )}
                            <div className="col-xl-10 col-lg-10 col-md-9 col-sm-9 col-8">
                                <div className="row align-items-center h-100">
                                    <div className="col-auto">
                                        {isBaseDataLoaded ? <SelectBizYear bizYear={selectedBizYear} bizYearList={bizYearList} onYearSearchHandler={this.onYearSearchHandler.bind(this)} /> : <></>}
                                    </div>
                                    <div className="col h4">{branchName}</div>
                                </div>
                            </div>
                        </div>
                        {isBaseDataLoaded && statAppAll ? (
                            <>
                                <div className="row">
                                    {statAppAll.map((app, idx) => {
                                        const yearStat = app.stat[selectedBizYear.year];
                                        const yearStatLast = app.stat[selectedBizYear.year - 1];
                                        return (
                                            <div className="col" style={{maxWidth: "220px"}} key={`card-start-${idx}`}>
                                                <CardStatContract
                                                    id={app.id}
                                                    type={app.typeId}
                                                    title={app.name}
                                                    totalCurrent={yearStat ? yearStat.countApNew + (yearStat.countApRe || 0) + (yearStat.countApOld || 0) : 0}
                                                    totalLast={yearStatLast ? yearStatLast.countApNew + (yearStatLast.countApRe || 0) + (yearStatLast.countApOld || 0) : 0}
                                                    totalNa={yearStat ? yearStat.countNaNew + yearStat.countNaRe : 0}
                                                    bSelectable={true}
                                                    bSelected={!selectedApp.typeId ? app.id === selectedApp.id : false}
                                                    onSelect={this.onAppSelect.bind(this)}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="row mt-3">
                                    {selectedBizYear.year > 2023 && statAppUnionAll.map((app, idx) => {
                                        const yearStat = app.stat[selectedBizYear.year];
                                        const yearStatLast = app.stat[selectedBizYear.year - 1];
                                        if(selectedBizYear.year == 2024 || app.typeUse) {
                                            return (
                                                <div className="col-2" style={{maxWidth: "220px"}} key={`card-start-${idx}`}>
                                                    <CardStatContract
                                                        id={app.id}
                                                        type={app.typeId}
                                                        title={app.typeName}
                                                        totalCurrent={yearStat ? yearStat.countApNew + (yearStat.countApRe || 0) + (yearStat.countApOld || 0) : 0}
                                                        totalLast={yearStatLast ? yearStatLast.countApNew + (yearStatLast.countApRe || 0) + (yearStatLast.countApOld || 0) : 0}
                                                        totalNa={yearStat ? yearStat.countNaNew + yearStat.countNaRe : 0}
                                                        bSelectable={true}
                                                        bSelected={app.id === selectedApp.id && app.typeId === selectedApp.typeId}
                                                        onSelect={this.onAppSelect.bind(this)}
                                                    />
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                        <hr />
                        <div>
                            {isBaseDataLoaded && statAppAll ? (
                                <>
                                    <CardStatContractApp appInfo={selectedApp} bizYear={selectedBizYear ? selectedBizYear.year : null} />
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <ContractChart
                                                chartData={selectedApp}
                                                height={315}
                                                yearChangeFn={this.onYearSearchHandler.bind(this)}
                                                bizYear={selectedBizYear ? selectedBizYear.year : null}
                                            />
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <TerminateChart chartData={selectedApp} bizYear={selectedBizYear ? selectedBizYear.year : null} height={315} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                            <MonthlyChart selectedApp={selectedApp} bizYear={selectedBizYear} chartData={statMonthly} />
                                        </div>
                                    </div>
                                    <ContractClassify bizYear={selectedBizYear.year} chartData={selectedApp} />
                                    {isRoleBranch ? (
                                        <div className="row">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                <StatList selectedApp={selectedApp} bizYear={selectedBizYear} dataList={statNurseries} height={400} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
                                                <BCGScatter selectedApp={selectedApp} dataList={statNurseries} height={400} />
                                            </div>
                                            <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                                                <StatList selectedApp={selectedApp} bizYear={selectedBizYear} dataList={statNurseries} isBranch={false} height={370} />
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                </div>
                <ToastContainer autoClose={2000} hideProgressBar={true} transition={Slide} />
            </div>
        );
    }
}

export default TasBranch;
